import React, { lazy, Suspense } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ScrollToTopOnRouteChange from "../services/scrollToTop";
import { useEffect, useState } from "react";
import PrivateRoute from "../Common/PrivateRoute.jsx";

const Home = lazy(() => import("../features/home/home"));
const About = lazy(() => import("../features/aboutUs/about"));
const Services = lazy(() => import("./our_services/service"));
const Portfolio = lazy(() => import("./portfolio/portfolio"));
const CaseStudy = lazy(() => import("./portfolio/casestudy/caseStudy"));
const Contactus = lazy(() => import("./contactUs/contactus"));
const GetInTouch = lazy(() => import("./getInTouch/getInTouch"));
// const HireDev = lazy(() => import("./hiredev/hiredev"));
// const Blog = lazy(() => import("./blog/blog"));
// const BlogDetail = lazy(() => import("./blog/blogDetail/blogDetail"));
// const ViewAllBlog = lazy(() => import("./blog/ViewAllCategory/ViewAllBlog"));
// const ViewAllRelatedBlog = lazy(() =>
//   import("./blog/ViewAllCategory/ViewAllRelatedBlog.jsx")
// );
// const ViewAllRelatedArticle = lazy(() =>
//   import("./blog/ViewAllCategory/ViewAllRelatedArticle.jsx")
// );
// const BlogPost = lazy(() => import("./blog/BlogPost/BlogPost"));
// const BlogForm = lazy(() => import("./blog/BlogForm/BlogForm"));
// const Register = lazy(() =>
//   import("../RegistrationFormModal/RegistrationForm.jsx")
// );
// const Login = lazy(() => import("../LoginFormModal/LoginForm.jsx"));
// const UserProfile = lazy(() => import("../UserProfile/Profile.jsx"));
// const Newsletter = lazy(() => import("./blog/newsletters/newsletter.jsx"));
// const Article = lazy(() => import("./blog/ViewAllCategory/ViewAllArticle.jsx"));
// const ArticlePost = lazy(() => import("./blog/ArticlePost/ArticlePost"));
// const EditContent = lazy(() => import("./blog/EditContent/EditContent.jsx"));
// const NewsletterPost = lazy(() =>
//   import("./blog/NewsletterPost/NewsletterPost.jsx")
// );
// const ViewAllNewsletter = lazy(() =>
//   import("./blog/ViewAllNewsletter/ViewAllNewsletter.jsx")
// );

export default function FeatureRoutes({ onChange }) {
  var handleImg = (img) => {
    onChange(img);
  };
  return (
    <Suspense fallback={<div>Loading...</div>}>
      {" "}
      {/* Add a fallback UI */}
      <ScrollToTopOnRouteChange />
      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/caseStudy/:id" element={<CaseStudy />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/getInTouch" element={<GetInTouch />} />
        {/* <Route path="/hiredev" element={<HireDev />} /> */}
        {/* <Route path="/blog" element={<Blog />} />
        <Route path="/blogDetail" element={<BlogDetail />} />
        <Route path="/viewallblog" element={<ViewAllBlog />} /> */}
        {/* <Route path="/viewAllRelatedblog" element={<ViewAllRelatedBlog />} />
        <Route
          path="/viewAllRelatedArticle"
          element={<ViewAllRelatedArticle />}
        />
        <Route path="/blogpost/:title" element={<BlogPost />} />
        <Route path="/articlepost/:title" element={<ArticlePost />} />
        <Route
          path="/newsletterpost/:id/:newsletteTitle"
          element={<NewsletterPost />}
        /> */}
        {/* <Route path="/login" element={<Login />} /> */}
        {/* This may change after discussion */}
        {/* <Route path="/blogform" element={<BlogForm />} />
        <Route path="/Register" element={<Register />} /> */}
        {/* <Route
          path="/userProfile"
          element={
            <PrivateRoute path="/blog">
              <UserProfile
                onChange={(img) => {
                  handleImg(img);
                }}
              />
            </PrivateRoute>
          }
        />
        <Route path="/newsletter" element={<Newsletter />} />
        <Route path="/viewallarticle" element={<Article />} />
        <Route path="/allNewsletter" element={<ViewAllNewsletter />} />
        <Route path="/editContent" element={<EditContent />} /> */}
        {/*         <Route path="/ViewAllCategory" element={<ViewAllBlog1/>} /> */}
      </Routes>
    </Suspense>
  );
}
